/**
 * @generated SignedSource<<cb59cada7ba8ed6cf1f023aa729823af>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type TicketAiSummaryState = "READY" | "NO_ACTIVITY" | "FAILED" | "PENDING" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type AiSummaryBlock_ticket$data = {
  readonly id: string;
  readonly aiSummaryState: TicketAiSummaryState;
  readonly aiSummary: {
    readonly summary: string;
    readonly statusSignal: string;
    readonly sentiment: string;
    readonly commentCount: number;
    readonly emailCount: number;
    readonly generatedAt: string;
    readonly modelVersion: string;
    readonly feedbackScore: number | null;
    readonly feedbackText: string | null;
    readonly isFinal: boolean;
    readonly staleness: {
      readonly isStale: boolean;
      readonly newComments: number;
      readonly newEmails: number;
      readonly newStatusEvents: number;
      readonly total: number;
    } | null;
  } | null;
  readonly " $fragmentType": "AiSummaryBlock_ticket";
};
export type AiSummaryBlock_ticket$key = {
  readonly " $data"?: AiSummaryBlock_ticket$data;
  readonly " $fragmentSpreads": FragmentRefs<"AiSummaryBlock_ticket">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AiSummaryBlock_ticket",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "aiSummaryState",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "TicketAiSummary",
      "kind": "LinkedField",
      "name": "aiSummary",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "summary",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "statusSignal",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "sentiment",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "commentCount",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "emailCount",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "generatedAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "modelVersion",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "feedbackScore",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "feedbackText",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isFinal",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "TicketAiSummaryStaleness",
          "kind": "LinkedField",
          "name": "staleness",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isStale",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "newComments",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "newEmails",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "newStatusEvents",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "total",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Ticket",
  "abstractKey": null
};

(node as any).hash = "34797a33e59857e0c1fa7e89a9045ba7";

export default node;
